import React, { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from 'styled-components';
import { signOut } from '../../services';
import Icon from '../icon/icon';
import * as s from './styled-bottom-nav';

// Bottom navigation — substitui o SideMenu rail em telas <=720px (phone),
// onde o hover do rail nao funciona (touch) e os 64px fixos comem espaco.
// 3 itens primarios + "Mais" (bottom sheet com o resto + tema + sair).
// Itens secundarios sao role-gated igual ao SideMenu.
const BottomNav = ({ handleChange }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { title } = useContext(ThemeContext);
  const [sheetOpen, setSheetOpen] = useState(false);

  const { user } = useSelector((state) => state.usuario);
  const { amount } = useSelector((state) => state.notifications);
  const bubbleCount = amount;
  const role = ((user && user.role) || '').toString().trim().toLowerCase();
  const selected = location.pathname.split('/')[1];

  const go = (path, resets) => {
    setSheetOpen(false);
    if (resets) {
      dispatch({ type: 'SEGUNDO/RESET' });
      dispatch({ type: 'APLICACAO/RESET' });
    }
    history.push(path);
  };

  // Itens do sheet "Mais" — mesma role-gating do SideMenu.
  const moreItems = [
    role === 'higra' && {
      key: 'customers',
      label: 'Clientes',
      icon: 'users',
      path: '/customers',
    },
    (role === 'higra' || role === 'admin') && {
      key: 'users',
      label: 'Usuários',
      icon: 'user-check',
      path: '/users',
    },
    role === 'higra' && {
      key: 'stations',
      label: 'Estações',
      icon: 'factory',
      path: '/stations',
    },
    role === 'higra' && {
      key: 'machines',
      label: 'Máquinas',
      icon: 'cpu',
      path: '/machines',
    },
    (role === 'higra' || role === 'admin') && {
      key: 'variables',
      label: 'Variáveis',
      icon: 'settings',
      path: '/variables',
    },
    role === 'higra' && {
      key: 'audit-logs',
      label: 'Logs',
      icon: 'history',
      path: '/audit-logs',
    },
  ].filter(Boolean);

  const handleLogout = async () => {
    setSheetOpen(false);
    try {
      await signOut();
      dispatch({ type: 'USUARIO/SET_USER', user: null });
      dispatch({ type: 'SEGUNDO/RESET' });
    } catch (e) {
      // silencioso — feedback opcional
    }
  };

  return (
    <>
      <s.Bar aria-label="Navegação principal">
        <s.Item
          type="button"
          $active={selected === 'dashboard'}
          onClick={() => go('/dashboard', true)}
        >
          {selected === 'dashboard' && <s.ActiveBar />}
          <Icon name="layout-dashboard" size={22} />
          <span className="lbl">Dashboard</span>
        </s.Item>

        <s.Item
          type="button"
          $active={selected === 'reports'}
          onClick={() => go('/reports')}
        >
          {selected === 'reports' && <s.ActiveBar />}
          <Icon name="bar-chart-3" size={22} />
          <span className="lbl">Relatórios</span>
        </s.Item>

        <s.Item
          type="button"
          $active={selected === 'notifications'}
          onClick={() => go('/notifications')}
        >
          {selected === 'notifications' && <s.ActiveBar />}
          <Icon name="bell" size={22} />
          {!!bubbleCount && <s.Badge>{bubbleCount}</s.Badge>}
          <span className="lbl">Alertas</span>
        </s.Item>

        <s.Item
          type="button"
          $active={sheetOpen}
          onClick={() => setSheetOpen((v) => !v)}
          aria-expanded={sheetOpen}
        >
          <Icon name="menu" size={22} />
          <span className="lbl">Mais</span>
        </s.Item>
      </s.Bar>

      {sheetOpen && (
        <>
          <s.SheetBackdrop onClick={() => setSheetOpen(false)} />
          <s.Sheet role="dialog" aria-modal="true" aria-label="Mais opções">
            <span className="grabber" />
            {moreItems.map((item) => (
              <s.SheetItem
                key={item.key}
                type="button"
                $active={selected === item.key}
                onClick={() => go(item.path)}
              >
                <Icon name={item.icon} size={22} />
                {item.label}
              </s.SheetItem>
            ))}
            <s.SheetItem type="button" onClick={handleChange}>
              <Icon name={title === 'dark' ? 'sun' : 'moon'} size={22} />
              {title === 'dark' ? 'Modo claro' : 'Modo escuro'}
            </s.SheetItem>
            <s.SheetItem
              type="button"
              className="danger"
              onClick={handleLogout}
            >
              <Icon name="log-out" size={22} />
              Sair
            </s.SheetItem>
          </s.Sheet>
        </>
      )}
    </>
  );
};

export default BottomNav;
